import React from "react";
import formatDate from "../../../utils/FormatDate";
import { Link } from "react-router-dom";

const MainOrdersTable = ({ orders }) => {
  return (
    <>
      <div className="container mx-auto p-4">
        <div className="flex flex-col lg:flex-row-reverse justify-between items-center mb-2">
          <h1 className="mb-4 text-right text-2xl font-semibold">
            أخر الطلبات الجديدة
          </h1>
          <Link
            to={`${process.env.PUBLIC_URL}/orders`}
            className="text-blue-500  px-4 py-2 rounded mb-4 text-xl font-semibold underline"
          >
            صفحة الطلبات
          </Link>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full overflow-hidden rounded-lg bg-white">
            <thead className="bg-gray-100">
              <tr className="text-sm uppercase leading-normal text-gray-600">
                <th className="px-4 py-3 text-right">عنوان العميل</th>
                <th className="px-4 py-3 text-right">السعر الكلي (العراقي)</th>
                <th className="px-4 py-3 text-right">عدد العناصر</th>
                <th className="px-4 py-3 text-right">تاريخ الطلب</th>
                <th className="px-4 py-3 text-right">صاحب الطلب</th>
              </tr>
            </thead>
            <tbody className="text-sm font-light text-gray-600">
              {orders.length !== 0 ? (
                orders.map((order) => {
                  return (
                    <tr
                      key={order.orderId}
                      className="border-b border-gray-200 hover:bg-gray-100"
                    >
                      <td className="px-4 py-4 text-right">
                        {order.regionNameAr}
                      </td>
                      <td className="px-4 py-4 text-right">
                        {order.totalIraqiprice}
                      </td>
                      <td className="px-4 py-4 text-right">
                        {order.items.length}
                      </td>
                      <td className="px-4 py-4 text-right">
                        {formatDate(order.orderdate)}
                      </td>
                      <td className="px-4 py-4 text-right">{order.name}</td>
                    </tr>
                  );
                })
              ) : (
                <tr className="border-b border-gray-200 hover:bg-gray-100">
                  <td className="px-4 py-4 text-right"></td>
                  <td className="px-4 py-4 text-right"></td>
                  <td className="px-4 py-4 text-right"></td>
                  <td className="px-4 py-4 text-right"></td>
                  <td className="px-4 py-4 text-right">
                    لا يوجد طلبات لأخر 24 ساعة
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default MainOrdersTable;
